<template>
  <div class="home">
    <p class="home-title">Positioning map creation</p>
    <h1>
      Web service that creates<br>
      a positioning map
    </h1>
    <nav>
      <ul>
        <li class="main">
          <v-btn
            dark
            depressed
            color="primary"
            x-large
            to="/list"
            style="font-size: 24px;"
          >
            Create Positioning Map
          </v-btn>
        </li>
        <li class="mt-2">
          <v-btn
            text
            color="primary"
            to="/howto"
            x-large
          >
            What you can do<br>and how to use
          </v-btn>
        </li>
      </ul>
    </nav>
    <p class="desc">Free to use<br>No user registration required<br><small>Recommended browser: Chrome, Safari, Firefox</small></p>
    <social-sharing url="https://www.positioning-map.com/"
      title="Positioning map creation tool"
      description="It is a tool to create a positioning map with a browser. Free to use. No user registration required."
      quote=""
      hashtags="Correlation,Positioning,Character"
      twitter-user=""
      inline-template>
      <div
        class="d-flex justify-space-between pt-4 pb-8 mx-auto"
        style="width: 120px;"
      >
        <network network="facebook">
          <i class="mdi mdi-facebook" style="color: #3B5998; font-size: 46px;"></i>
        </network>
        <network network="twitter">
          <i class="mdi mdi-twitter" style="color: #1DA1F2; font-size: 46px;"></i>
        </network>
      </div>
    </social-sharing>
    <div class="lang">
      <v-btn text color="primary" to="/">Japanese</v-btn>
    </div>
    <nav class="mt-8">
      <ul>
        <li>
          <v-btn
            color="white"
            text
            to="/about"
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
            <span class="link-text">About service</span>
          </v-btn>
        </li>
        <li>
          <v-btn
            color="white"
            text
            to="/developer"
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
            <span class="link-text">About developer</span>
          </v-btn>
        </li>
        <li>
          <v-btn
            color="white"
            text
            to="/terms"
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
            <span class="link-text">Terms of service</span>
          </v-btn>
        </li>
      </ul>
    </nav>
    <!-- <v-btn
      color="pink"
      text
      href="https://twitter.com/i/events/828794174270951425?s=13"
      class="thanks"
      small
    >
      <v-icon
        small
      >
        mdi-cards-heart
      </v-icon>
      Thanks
    </v-btn> -->
    <div class="copyright">
      <small>&copy; www.positioning-map.com</small>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Correlation diagram creation tool | Tool to create person and character correlation diagrams.',
    meta: [
      { name: 'description', content: 'It is a tool to create a correlation diagram with a browser.' }
    ]
  },
  mounted () {
    this.$i18n.locale = 'en'
  }
}
</script>
